import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../api/api';

const tokenKey = 'access_token';
const refreshKey = 'refresh_token';
const userKey = 'user';

export const registerUser = createAsyncThunk('auth/register', async (userData, thunkAPI) => {
  try {
    const res = await api.post('/auth/signup', userData);
    return res.data;
  } catch(err) {
    return thunkAPI.rejectWithValue(err.response.data);
  }
});

export const loginUser = createAsyncThunk('auth/login', async (credentials, thunkAPI) => {
  try {
    const res = await api.post('/auth/login', credentials);
    if (res.data.access_token) {
      localStorage.setItem(tokenKey, res.data.access_token);
      // console.log("Login Successful - ", res.data);
    }
    return res.data;
  } catch (err) {
    console.log("### Login failed - ", err);
    const msg = err?.response?.data?.message || 'Login failed';

    return thunkAPI.rejectWithValue(msg);
  }
});

const initialToken = localStorage.getItem(tokenKey);

const authSlice = createSlice({
  name: 'auth',
  initialState: { user: JSON.parse(localStorage.getItem(userKey) || 'null'),
                  token:initialToken || null,
                  refreshToken: localStorage.getItem(refreshKey) || null,

                  mustChangePassword: false,
                  emailVerified: true,
                  loading: false,
                  status: 'idle',
                  error: null
                },
  reducers: {
    logout: (state) => {
      state.user = null;
      state.token = null;
      state.refreshToken=null;
      state.error = null;
      state.loading = false;
      state.status = 'idle';
      localStorage.removeItem(tokenKey);
      localStorage.removeItem(refreshKey);
    },
    setToken(state, action) {
      state.token = action.payload;
      if (action.payload) {
          localStorage.setItem(tokenKey, action.payload);
      }
    },
    setRefreshToken(state, action) {
      state.refreshToken = action.payload;
      localStorage.setItem(refreshKey, action.payload);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(registerUser.pending, (state) => {
            state.loading = true;
            state.status = 'loading';
            state.error = null;
      })
      .addCase(registerUser.fulfilled, (state, action) => {
            state.loading = false;
            state.status = 'succeeded';
            state.user = action.payload.user;
            state.token = action.payload.access_token;
            state.error = null;
            state.mustChangePassword = action.payload.user.must_change_password;
            state.emailVerified = action.payload.user.email_verified;

            // localStorage.setItem(tokenKey, action.payload.access_token);
      })
      .addCase(registerUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message;
          // state.error = action.error.message;
        state.status = 'failed';
      })
      .addCase(loginUser.pending, (state) => {
            state.loading = true;
            state.status = 'loading';
            state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        // console.log("Saving State when Payload is ", action.payload);
        state.loading = false;
        state.user = action.payload.user;
        state.status = 'succeeded';
        state.token = action.payload.access_token;
        state.refreshToken = action.payload.refresh_token;

        state.error = null;
        state.mustChangePassword = action.payload.user.must_change_password;
        state.emailVerified = action.payload.user.email_verified;

        localStorage.setItem(tokenKey, action.payload.access_token);
        localStorage.setItem(userKey, JSON.stringify(action.payload.user));
        localStorage.setItem(refreshKey, action.payload.refresh_token);

      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;

        console.log("### Login rejected with error: ", action);
        state.error = action.payload;
          // state.error = action.error.message;
        state.status = 'failed';
      });
  },
});

export const { logout, setToken, setRefreshToken } = authSlice.actions;
export default authSlice.reducer;

